import React from 'react';
// import PropTypes from 'prop-types';
import { defineMessages, injectIntl } from 'react-intl';

// import * as AppPropTypes from '../../lib/PropTypes';
import PageMeta from '../partials/PageMeta';
import PageHeading from '../partials/PageHeading';

import styles from '../../../styles/pages/interactive.scss';

const messages = defineMessages({
    metaTitle: {
        id: 'meta.title',
        defaultMessage: 'Title',
    },
    interactiveTitle: {
        id: 'content.sections_title.interactive',
        defaultMessage: 'Interactive',
    },
    interactiveSubtitle: {
        id: 'content.sections_subtitle.interactive',
        defaultMessage: 'Example an interactive subtitle',
    },
});

const propTypes = {};

const defaultProps = {};

const Interactive = () => (
    <div className={styles.container}>
        <PageMeta title={messages.metaTitle} />
        <PageHeading
            title={messages.interactiveTitle}
            subtitle={messages.interactiveSubtitle}
            className={styles.pageHeading}
        />
    </div>
);

Interactive.propTypes = propTypes;
Interactive.defaultProps = defaultProps;

const WithIntlContainer = injectIntl(Interactive);

export default WithIntlContainer;
